export function getReadableTextColor(hexColor) {
  const normalizedColor = hexColor.replace('#', '');
  const color = normalizedColor.length === 3
    ? normalizedColor.split('').map(value => `${value}${value}`).join('')
    : normalizedColor;
  const [red, green, blue] = [0, 2, 4].map(index => parseInt(color.slice(index, index + 2), 16) / 255);
  const luminance = [red, green, blue].reduce((total, channel, index) => {
    const linearChannel = channel <= 0.03928
      ? channel / 12.92
      : ((channel + 0.055) / 1.055) ** 2.4;
    return total + linearChannel * [0.2126, 0.7152, 0.0722][index];
  }, 0);
  const blackContrast = (luminance + 0.05) / 0.05;
  const whiteContrast = 1.05 / (luminance + 0.05);

  return whiteContrast > blackContrast ? '#fff' : '#000';
}